import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { getWorkOrderStatus } from '../api/work-order-statusAPI';
import { updateWorkOrder } from '../api/work-orderAPI';
import { getTrades } from '../api/tradesAPI';
import { getExpenseCodes } from '../api/expense-codeAPI';
import { getExternalServices } from '../api/external-servicesAPI';
import { getFailureCodes } from '../api/failure-codeAPI';
import { getCauseCodes } from '../api/cause-codeAPI';
import { fetchData } from '../utils/apiHelpers';
import WorkOrderDetails from './WorkOrderDetails';

const WorkOrderViewModal = ({
  workOrder,
  parts = [],
  labour = [],
  services = [],
  equipment = [],
  forms = [],
  onViewForm,
  onExportPdf,
  crew = [],
  onClose,
  refresh,
  onEdit,
}) => {
  const [statuses, setStatuses] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(workOrder.status);
  const [partsState] = useState(parts);
  const [equipmentState] = useState(equipment);
  const [labourState] = useState(labour);
  const [servicesState] = useState(services);
  const [formsState] = useState(forms);
  const [isExporting, setIsExporting] = useState(false);

  const [, setTradeOptions] = useState([]);
  const [, setExpenseOptions] = useState([]);
  const [, setServiceOptions] = useState([]);

  useEffect(() => {
    fetchData(getWorkOrderStatus, {}, setStatuses);
  }, []);

  useEffect(() => {
    fetchData(getTrades, {}, setTradeOptions);
    fetchData(getExpenseCodes, {}, setExpenseOptions);
    fetchData(getExternalServices, {}, setServiceOptions);
    fetchData(getFailureCodes, {});
    fetchData(getCauseCodes, {});
  }, []);

  const handleStatusChange = async (id) => {
    try {
      await updateWorkOrder(workOrder.id, { statusId: id });
      const newStatus = statuses.find((s) => s.id === id);
      if (newStatus) setCurrentStatus(newStatus);
      if (refresh) refresh();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div className="modal modal-backdrop show d-block" tabIndex="-1">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title flex-grow-1">
                #{workOrder.workOrderNumber} - {workOrder.workOrderTitle}
              </div>
              <button
                type="button"
                className="btn btn-outline-warning btn-sm d-flex align-items-center"
                onClick={async () => {
                  if (!onExportPdf || isExporting) return;
                  try {
                    setIsExporting(true);
                    await Promise.resolve(onExportPdf(workOrder));
                  } catch (error) {
                    console.error(error);
                  } finally {
                    setIsExporting(false);
                  }
                }}
                disabled={isExporting}
              >
                {isExporting && (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
                <span>{isExporting ? 'Preparing PDF…' : 'Export to PDF'}</span>
              </button>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <WorkOrderDetails
                workOrder={workOrder}
                crew={crew}
                statuses={statuses}
                currentStatus={currentStatus}
                onStatusChange={handleStatusChange}
                parts={partsState}
                labour={labourState}
                services={servicesState}
                equipment={equipmentState}
                forms={formsState}
                onViewForm={onViewForm}
              />
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default WorkOrderViewModal;
